/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Section14FeeRenegotiation } from './Section14FeeRenegotiation';
import {
    Section14FeeRenegotiationFromJSON,
    Section14FeeRenegotiationFromJSONTyped,
    Section14FeeRenegotiationToJSON,
} from './Section14FeeRenegotiation';

/**
 * 
 * @export
 * @interface OutstandingSection14FeeRenegotiations
 */
export interface OutstandingSection14FeeRenegotiations {
    /**
     * 
     * @type {Array<Section14FeeRenegotiation>}
     * @memberof OutstandingSection14FeeRenegotiations
     */
    section14Renegotiations: Array<Section14FeeRenegotiation>;
}

/**
 * Check if a given object implements the OutstandingSection14FeeRenegotiations interface.
 */
export function instanceOfOutstandingSection14FeeRenegotiations(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "section14Renegotiations" in value;

    return isInstance;
}

export function OutstandingSection14FeeRenegotiationsFromJSON(json: any): OutstandingSection14FeeRenegotiations {
    return OutstandingSection14FeeRenegotiationsFromJSONTyped(json, false);
}

export function OutstandingSection14FeeRenegotiationsFromJSONTyped(json: any, ignoreDiscriminator: boolean): OutstandingSection14FeeRenegotiations {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'section14Renegotiations': ((json['Section14Renegotiations'] as Array<any>).map(Section14FeeRenegotiationFromJSON)),
    };
}

export function OutstandingSection14FeeRenegotiationsToJSON(value?: OutstandingSection14FeeRenegotiations | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'Section14Renegotiations': ((value.section14Renegotiations as Array<any>).map(Section14FeeRenegotiationToJSON)),
    };
}

